import { Component, effect, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
// services
import { ChatService } from '@app/+chat/shared/services/chat.service';
import { ButtonComponent } from '@app/core/components/button/button.component';
// components
import { InputComponent } from '@app/core/components/input/input.component';
import { PhoneNumberComponent } from '@app/core/components/phone-number/phone-number.component';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
import { StorageService } from '@app/shared/services/storage.service';
// enums
import { AlertStatesEnum } from '@app/+chat/shared/enums/alert-states.enum';

@Component({
  selector: 'pwj-public-chat-form',
  standalone: true,
  imports: [
    InputComponent,
    PhoneNumberComponent,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    TranslateModule,
    NgOptimizedImage,
  ],
  templateUrl: './public-chat-form.component.html',
  styleUrl: './public-chat-form.component.scss',
})
export class PublicChatFormComponent {
  // form property
  public publicChatForm!: FormGroup;
  public isChatLoading!: boolean;

  // dependencies
  private readonly _fb = inject(FormBuilder);
  private readonly _chatService = inject(ChatService);
  private readonly _stateManagementService = inject(StateManagementService);
  private readonly _storageService = inject(StorageService);

  constructor() {
    this._buildForm();

    effect(() => {
      const chatData = this._stateManagementService.oneChatById();

      if (chatData?._id) {
        this.publicChatForm.reset();

        this._stateManagementService.chatAlertState.set(
          AlertStatesEnum.supportChat
        );
      }
    });

    effect(() => {
      this.isChatLoading = this._stateManagementService.isCreateChatLoading();
    });
  }

  // build contact form
  private _buildForm() {
    this.publicChatForm = this._fb.group({
      name: new FormControl(null, Validators.required),
      mobile: new FormControl(null, Validators.required),
    });
  }

  public submitContactForm() {
    // check form is valid or no
    if (!this.publicChatForm.valid) {
      this.publicChatForm.markAllAsTouched();
      return;
    }

    // get form values
    const formData = this.publicChatForm.value;
    // post data
    this._chatService.createSupportChat(formData);
  }
}
